/* eslint-disable react/destructuring-assignment */
import { useAccount } from "hooks/useAccounts";
import CustomData from "pages/_components/CustomData/CustomData";
// import CustomText from "pages/_components/CustomText/CustomText";
import GridTable from "pages/_components/GridTable/GridTable";
import Loader from "pages/_components/Loader";
import { TransactionSign } from "pages/_components/TransactionCard";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { bool, number, string } from "prop-types";
import React, { useContext } from "react";

const EcheckRequestSummaryBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {} } = transaction;

    const { idAccount = props.idAccount, amount = props.amount } = data;

    const { fetching, account, formatAccountBody } = useAccount("productId", idAccount);

    if (fetching) {
        return <Loader />;
    }

    return (
        <GridTable className="form-summary">
            <GridTable.Container columns={props.ticket ? 2 : 3} rows={1} columnsTemplate="fixed">
                <GridTable.Data columnStart={1} rowStart={1}>
                    <CustomData
                        titleTextType="I18N"
                        titleText="echeq.request.account.label"
                        valueClass="data-label"
                        valueText={formatAccountBody(account)}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={1} columnWidth={1}>
                    <CustomData
                        titleTextType="I18N"
                        titleText="echeq.request.amount.label"
                        valueClass="data-label"
                        valueText={amount}
                    />
                </GridTable.Data>
            </GridTable.Container>
            {props.ticket && (
                <TransactionSign
                    isDesktop={props.isDesktop}
                    showMoreData
                    customText={props.backofficePending ? "pending.approval.cybo" : null}
                />
            )}
        </GridTable>
    );
};

EcheckRequestSummaryBody.propTypes = {
    idAccount: string,
    amount: number,
    ticket: bool,
    isDesktop: bool,
    backofficePending: bool,
};

EcheckRequestSummaryBody.defaultProps = {
    idAccount: "",
    amount: null,
    ticket: false,
    isDesktop: false,
    backofficePending: false,
};

export default EcheckRequestSummaryBody;
